import { Pipe, PipeTransform } from '@angular/core';

import { LevenshteinService } from '../../../baseBtl/base/services/levenshtein.service';

@Pipe({
    name: 'filterObj',
    pure: false,
})
export class FilterObjPipe implements PipeTransform {
    constructor(protected levenshteinService: LevenshteinService) {}

    /* eslint-disable */
    public transform(
        items: any[],
        filter: { [index: string]: any },
        strict: boolean | { [index: string]: boolean } = false,
        caseSensitive: boolean = false,
    ): any {
        if (!items || !filter) {
            return items;
        }

        return items.filter((item) => {
            for (let key in filter) {
                if (filter[key] && !item[key]) {
                    return false;
                }
                if (item[key] || item[key] == '') {
                    let value: string = caseSensitive ? item[key] : item[key].toUpperCase();

                    if (filter[key] instanceof Array) {
                        //FILTER ARRAY KEYS

                        let foundInFilterArray = false;
                        for (let subkey in filter[key]) {
                            let filterValue: string = caseSensitive
                                ? filter[key][subkey]
                                : filter[key][subkey].toUpperCase();

                            if (
                                (!strict && typeof strict != 'object') ||
                                (typeof strict == 'object' && !strict[key][subkey])
                            ) {
                                if (value == filterValue) {
                                    foundInFilterArray = true;
                                }
                            } else {
                                if (value == filterValue && filterValue) {
                                    foundInFilterArray = true;
                                }
                            }
                        }
                        if (!foundInFilterArray) {
                            return false;
                        }
                    } else {
                        //FILTER STRING
                        let filterValue: string =
                            filter[key] && caseSensitive ? filter[key].toUpperCase() : filter[key];
                        if ((!strict && typeof strict != 'object') || (typeof strict == 'object' && !strict[key])) {
                            if (
                                this.levenshteinService.calculateDistance(value, filterValue) > 2 &&
                                value != filterValue &&
                                filterValue
                            ) {
                                return false;
                            }
                        } else {
                            if (value != filterValue && filterValue) {
                                return false;
                            }
                        }
                    }
                }
            }
            return true;
        });
    }
}
